{
  "name": "icc-offb",
  "version": "1.0.6",
  "scripts": {
    "ng": "ng",
    "start": "node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng serve",
    "build_prod": "clear && ng build --configuration production && mv ./www/browser/* ./www",
    "build_mobile": "clear && ng build --configuration production && mv ./www/browser/* ./www && npx cap sync",
    "dev_mobile": "clear && ng build --configuration development && mv ./www/browser/* ./www && npx cap sync",
    "build": "ng build --configuration production --aot --output-hashing=all",
    "build_test": "ng build --configuration development --aot --output-hashing=all",
    "build_test_mobile": "clear && ng build --configuration development --aot --output-hashing=all && mv ./www/browser/* ./www && npx cap sync",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:ICC-OFFB": "node dist/icc-offb/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/platform-browser": "17",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@angular/ssr": "^17.3.8",
    "@capacitor-firebase/authentication": "^7.1.0",
    "@capacitor/android": "^6.2.0",
    "@capacitor/app": "^7.0.1",
    "@capacitor/cli": "^6.2.0",
    "@capacitor/core": "^6.2.0",
    "@capacitor/ios": "^6.2.0",
    "@capacitor/push-notifications": "^7.0.1",
    "@capacitor/splash-screen": "^6.0.3",
    "appsflyer-capacitor-plugin": "^6.15.2",
    "browser-image-compression": "^2.0.2",
    "canvas-compressor-image": "^1.0.0",
    "cordova-plugin-camera": "^8.0.0",
    "cordova-plugin-device": "^3.0.0",
    "cordova-plugin-network-information": "^3.0.0",
    "express": "^4.18.2",
    "firebase": "^11.1.0",
    "jetifier": "^2.0.0",
    "jwt-decode": "^4.0.0",
    "ng-recaptcha": "^13.2.1",
    "ngx-pull-to-refresh": "^17.0.0",
    "ngx-toastr": "^19.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.10",
    "rxjs": "~7.8.1",
    "slugify": "^1.6.6",
    "swiper": "^11.1.14",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular/cli": "^17.3.8",
    "@angular/compiler-cli": "^17.3.0",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.20",
    "browserslist": "^4.24.4",
    "caniuse-lite": "^1.0.30001699",
    "cordova-android": "^13.0.0",
    "cordova-ios": "^7.1.1",
    "cordova-plugin-androidx": "^3.0.0",
    "cordova-plugin-androidx-adapter": "^1.1.3",
    "cordova-plugin-file": "^8.1.3",
    "cordova-plugin-file-transfer": "github:apache/cordova-plugin-file-transfer",
    "cordova-plugin-ionic-webview": "^5.0.1",
    "cordova-plugin-wkwebview-engine": "^1.2.2",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "phonegap-plugin-mobile-accessibility": "github:phonegap/phonegap-mobile-accessibility",
    "postcss": "^8.4.47",
    "tailwindcss": "^3.4.12",
    "typescript": "~5.4.2"
  },
  "cordova": {
    "plugins": {
      "cordova-plugin-file-transfer": {},
      "cordova-plugin-ionic-webview": {
        "ANDROID_SUPPORT_ANNOTATIONS_VERSION": "27.+"
      },
      "cordova-plugin-androidx": {},
      "cordova-plugin-androidx-adapter": {},
      "cordova-plugin-wkwebview-engine": {}
    },
    "platforms": [
      "android"
    ]
  }
}
